
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic02 as ObiHydraulic02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-02.js';
 
 
 

 
 export const ObiHydraulic02 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-02',
   elementClass: ObiHydraulic02Element,
   events: {
     
   }
  });
 
 